import React from 'react'
import { SAVE_ABANDONEDCART,CLEAR_ABANDONEDCART } from '../../constantTypes/abondanedcart/abondanedCartConstantTypes';
export const  AbandonedCartReducer=(state={},action)=> {
  
  switch (action.type) {
      case SAVE_ABANDONEDCART:
          
          return {...state,adonentcartformvalues:action.payload}
      case CLEAR_ABANDONEDCART:
          
            return {...state,adonentcartformvalues:{}}
  
      default:  return state;
  }
}
 